import {$,$$} from '../core/dom.js';

export function initHome({motion,navigation,sound}){
  const button=$('#stopShameOrb'),message=$('#stopOrbMessage');let pressAnimation=null,busy=false,held=false;
  function press(){
    if(busy||held)return;held=true;if(motion.isReduced())return;pressAnimation?.cancel();
    pressAnimation=button.animate([
      {transform:'translateY(0) scale(1)',filter:'drop-shadow(0 15px 18px rgba(121,48,82,.20))'},
      {transform:'translateY(4px) scale(.93)',filter:'drop-shadow(0 5px 8px rgba(121,48,82,.16))'}
    ],{duration:90,easing:'ease-out',fill:'forwards'});
  }
  function release(){
    if(!held)return;held=false;pressAnimation?.cancel();pressAnimation=null;if(motion.isReduced())return;
    pressAnimation=button.animate([
      {transform:'translateY(4px) scale(.93)',filter:'drop-shadow(0 5px 8px rgba(121,48,82,.16))'},
      {transform:'translateY(-1px) scale(1.02)',filter:'drop-shadow(0 16px 19px rgba(121,48,82,.20))',offset:.62},
      {transform:'translateY(0) scale(1)',filter:'drop-shadow(0 15px 18px rgba(121,48,82,.20))'}
    ],{duration:220,easing:'cubic-bezier(.2,.75,.25,1)'});
  }
  button.addEventListener('pointerdown',event=>{if(event.button===0){button.setPointerCapture(event.pointerId);press()}});
  button.addEventListener('pointerup',release);
  button.addEventListener('pointercancel',()=>{held=false;pressAnimation?.cancel();pressAnimation=null});
  button.addEventListener('keydown',event=>{if((event.key===' '||event.key==='Enter')&&!event.repeat)press()});
  button.addEventListener('keyup',event=>{if(event.key===' '||event.key==='Enter')release()});
  button.addEventListener('blur',()=>{held=false;pressAnimation?.cancel();pressAnimation=null});
  button.addEventListener('click',async()=>{
    if(busy)return;if(held)release();busy=true;sound.playStopPress();message.classList.add('show');
    await new Promise(resolve=>setTimeout(resolve,320));navigation.showScreen('router');message.classList.remove('show');busy=false;
  });
  motion.subscribe(({reduced})=>{if(reduced){pressAnimation?.cancel();pressAnimation=null;held=false}});
  $$('[data-v07-open]').forEach(control=>control.addEventListener('click',()=>navigation.showScreen(control.dataset.v07Open)));
  $$('.home-v07-choice[data-route="start"]').forEach(control=>control.addEventListener('click',()=>navigation.showScreen('roll')));
}
